import * as React from 'react'

interface ToasterProps {}

const { Provider, Consumer } = React.createContext<ToasterProps>({})

export { Provider, Consumer }
